import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from 'ramda';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { selectAccountUsersQueryItems } from '../../../../../../redux/account-users/selector';
import AccountLedgerComponent from '../components/account-ledger.component';
import { accountCategories } from '../../../../../../redux/account-categories/action';
import { selectAccountCategoriesListItems } from '../../../../../../redux/account-categories/selector';
import { accountLedgers } from '../../../../../../redux/account-ledgers/action';
import { selectAccountLedgersQueryItems } from '../../../../../../redux/account-ledgers/selector';

const ManagementAccountsLedger = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const accountCategoriesListData = useSelector(selectAccountCategoriesListItems)
    const queryItems = useSelector(selectAccountLedgersQueryItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [selectedAccountLedgers, setSelectedAccountLedgers] = useState<any>([])
    const [selectedAddress, setSelectedAddress] = useState<any>([])

    const fetchAccountLedgersById = () => {
        dispatch(accountLedgers.query({
            url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-applications/accounts/ledgers/fetch-detail`,
            entity: 'accountLedgers',
            jsonData: {
                Records: [
                    {
                        Id: parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    const handleInnerBasicFormChange: any = (event: any, field: string) => {
        setSelectedAccountLedgers({ ...selectedAccountLedgers, [field]: event })
    }

    const handleInnerFormChange: any = (event: any, field: string, data: any) => {
        const fields = R.split(
            '.',
            field
        );
        const value = { ...data, [fields[1]]: event }
        setSelectedAccountLedgers({ ...selectedAccountLedgers, [fields[0]]: value });
        setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
    }

    useEffect(
        () => {
            dispatch(accountCategories.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/account-categories/list`,
                entity: 'accountCategories',
                jsonData: {}
            })).then(() => {
                if (parmas?.id > 0) {
                    fetchAccountLedgersById()
                    setIsLoading(false)
                } else {
                    setIsLoading(false)
                }
            })
        }, []
    )

    useEffect(
        () => {
            if (isQuery) {
                setSelectedAccountLedgers(queryItems?.result?.items)
            }
        }, [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        const accountlegderData = {
            Id: selectedAccountLedgers?.Id || 0,
            AccountCategoryId: selectedAccountLedgers?.AccountCategoryId || 0,
            LedgerName: selectedAccountLedgers?.LedgerName || '',
            Description: selectedAccountLedgers?.Description || '',
            OpeningBalance: selectedAccountLedgers?.OpeningBalance || 0,
            MailingAddress: selectedAddress?.PrimaryAddress || {},
            TaxRegistration: selectedAccountLedgers?.TaxRegistration || {},
            BankAccount: selectedAccountLedgers?.BankAccount || {}
        }
        if (parmas?.id > 0) {
            await dispatch(accountLedgers.resetAction({ actionType: 'update' }))
            await dispatch(accountLedgers.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/ledgers`,
                entity: 'accountLedgers',
                jsonData: {
                    Records: [
                        accountlegderData
                    ]
                }
            })).then(() => {
                back()
            })
        } else {
            await dispatch(accountLedgers.resetAction({ actionType: 'create' }))
            await dispatch(accountLedgers.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/ledgers`,
                entity: 'accountLedgers',
                jsonData: {
                    Records: [
                        accountlegderData
                    ]
                }
            })).then(() => {
                back()
            })
        }
    }

    const back = () => {
        // navigate('/management/e-applications/accounts/ledger');
        navigate(-1)
    };

    return (
        <>
            {isLoading ? <PageLoader /> :
                <AccountLedgerComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedAccountLedgers={selectedAccountLedgers}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    id={parmas?.id}
                    handleInnerBasicFormChange={handleInnerBasicFormChange}
                    selectedAddress={selectedAddress}
                    accountCategoriesList={accountCategoriesListData?.result?.items}
                />
            }
        </>
    )
}

export default ManagementAccountsLedger;